<template>
  <el-dialog
    title="Constant Contact Accounts"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    @open="open"
  >

    <loader
      v-if="$apollo.loading || loadingContacts"
      msg="Loading"
    />

    <div
      v-for="account in contactAccounts"
      :key="account.id"
      v-else
    >
      <div class="ibox-title">
        <h5>{{parseProviderName(account.provider)}}</h5>
      </div>
      <contact-lists-select
        :id="account.id"
        :provider="account.provider"
        @selectedListsChange="handleSelectedListsChange"
      />
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="handleImportClick"
        v-if="!$apollo.loading && !loadingContacts"
      >
        Import Contacts
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import gql from 'graphql-tag';
import contactAccountsListProviderQuery from '@/graphql/contacts/contactAccountsListProvider.gql';
import Loader from '@/components/common/Loader';
import { parseProviderName } from '@/helpers/contact';
import ContactListsSelect from './ContactListsSelect';

export default {
  name: 'ConstantContactDialog',
  components: {
    ContactListsSelect,
    Loader,
  },
  props: {
    contacts: {
      type: Array,
      default: () => [],
    },
    loadingContacts: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => ['EMAIL', 'FIRST NAME', 'LAST NAME', 'HOME PHONE'],
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    errorMessage: {
      type: String,
      default:
        'No emails were provided in this survey, make sure the survey asks for an email address.',
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.isVisible;
      },
      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
  },
  data: () => ({
    contactAccounts: [],
    selectedLists: {},
    lists: [],
  }),
  apollo: {
    $client: 'apiv2',
    contactAccounts: {
      query: contactAccountsListProviderQuery,
      prefetch: true,
      variables() {
        return {
          provider: 'constant_contact',
        };
      },
    },
  },
  methods: {
    parseProviderName,
    handleSelectedListsChange(id, lists) {
      this.selectedLists[id] = lists;
    },
    buildMutations() {
      let mutations = [];
      Object.keys(this.selectedLists).forEach(key => {
        const val = this.selectedLists[key];
        this.importData = {
          import_data: [...this.contacts],
          lists: [...this.lists, ...val],
          column_names: [...this.columns],
        };
        mutations = [
          ...mutations,
          {
            client: 'apiv2',
            mutation: gql`
              mutation($id: String!, $batchImport: Json!) {
                constantContactImport(id: $id, batchImport: $batchImport) {
                  id
                  type
                  errorCount
                  contactCount
                }
              }
            `,
            variables: { id: key, batchImport: this.importData },
          },
        ];
      });
      return mutations;
    },
    open() {
      this.$emit('open');
    },
    async handleImportClick() {
      if (this.contacts.length === 0) {
        this.$notify({
          title: 'No emails provided!',
          message: this.errorMessage,
          type: 'warning',
        });
        this.dialogVisible = false;
        return;
      }

      const mutations = this.buildMutations();

      mutations.forEach(async mutation => {
        await this.$apollo.mutate(mutation);
      });
      this.$notify({
        title: 'Contacts imported!',
        message: 'Contacts have been imported into the selected lists.',
        type: 'success',
      });
      this.dialogVisible = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConstantContactDialog.vue?9d502cfc